import React from "react";
import MatchWrapper from "./layout/MatchWrapper";
import CheerTab from "./layout/Tab";
import Cheer from "./layout/Cheer";
import styled from "styled-components";
import BannerSportCheer from "../../components/banner-sport-cheer";

const ScoreMatchLayout = ({ children, sportsType, gameData, selectType }) => {
  return (
    <Container>
      <LeftSide>
        <LogoHead>
          <img
            alt="네임드"
            src="https://image.named.com/portal/none_logo.png"
          />
        </LogoHead>
        <LeftContent>
          <MatchWrapper sportsType={sportsType} gameData={gameData} />
          <CheerTab selectType={selectType} sportsType={sportsType} />
          <BannerSportCheer />
          {children}
        </LeftContent>
      </LeftSide>
      <RightSide>
        <Cheer sportsType={sportsType} detail={gameData.detail} />
      </RightSide>
    </Container>
  );
};

export default ScoreMatchLayout;

const Container = styled.div`
  width: 100%;
  max-width: 1000px;
  height: 100%;
  background: #fff;
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  justify-content: flex-start;
  margin: 0 auto;

  & a:hover {
    text-decoration: none;
  }
`;
const LeftSide = styled.div`
  width: 700px;
  height: 100%;
  min-width: 700px;
`;
const LogoHead = styled.div`
  padding: 0 30px;
  height: 50px;
  background: #ed2026;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  & > img {
    height: 15px;
  }
`;

const LeftContent = styled.div`
  border: 1px solid #e0e0e0;
  border-top: none;
  height: calc(100% - 51px);
  background: rgb(241, 242, 244);
  overflow-y: scroll;
  ::-webkit-scrollbar {
    display: none;
  }
`;

const RightSide = styled.div`
  min-width: 300px;
  height: 100%;
  overflow-y: scroll;
  ::-webkit-scrollbar {
    display: none;
  }
`;
